export const etudiantsConstants = {
  GET_ETUDIANTS: "GET_ETUDIANTS",
  GET_ETUDIANT: "GET_ETUDIANTS",
  GET_CARTE: "GET_CARTE"
};
